var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    preserveAspectRatio: "xMinYMin slice",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9206 18.3525C94.6563 18.3525 96.0634 19.7596 96.0634 21.4954V89.6689C96.0634 95.8618 90.9502 100.858 84.7753 100.858H28.4749C26.7391 100.858 25.332 99.4511 25.332 97.7153C25.332 95.9796 26.7391 94.5725 28.4749 94.5725H84.7753C87.5513 94.5725 89.7777 92.3182 89.7777 89.6689V21.4954C89.7777 19.7596 91.1848 18.3525 92.9206 18.3525Z",
    fill: "#D2E5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8038 96.8318C20.6865 96.8318 17.2852 93.4717 17.2852 89.4043V55.0081V18.0476C17.2852 13.9802 20.6865 10.6201 24.8038 10.6201H84.3266C88.4439 10.6201 91.8452 13.9802 91.8452 18.0476V89.4043C91.8452 93.4717 88.4439 96.8318 84.3266 96.8318H24.8038Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.804 12.0336C21.4514 12.0336 18.6997 14.7767 18.6997 18.0468V89.4035C18.6997 92.6737 21.4514 95.4167 24.804 95.4167H84.3268C87.6794 95.4167 90.4312 92.6737 90.4312 89.4035V18.0468C90.4312 14.7767 87.6794 12.0336 84.3268 12.0336H24.804ZM15.8711 18.0468C15.8711 13.1821 19.9219 9.20508 24.804 9.20508H84.3268C89.2089 9.20508 93.2597 13.1821 93.2597 18.0468V89.4035C93.2597 94.2683 89.2089 98.2453 84.3268 98.2453H24.804C19.9219 98.2453 15.8711 94.2683 15.8711 89.4035V18.0468Z",
    fill: "#3694E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9443 64.382C29.9443 63.5141 30.6479 62.8105 31.5158 62.8105H59.3527C60.2206 62.8105 60.9241 63.5141 60.9241 64.382C60.9241 65.2499 60.2206 65.9534 59.3527 65.9534H31.5158C30.6479 65.9534 29.9443 65.2499 29.9443 64.382Z",
    fill: "#DEE9F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9443 55.005C29.9443 54.1371 30.6479 53.4336 31.5158 53.4336H78.0599C78.9277 53.4336 79.6313 54.1371 79.6313 55.005C79.6313 55.8729 78.9277 56.5765 78.0599 56.5765H31.5158C30.6479 56.5765 29.9443 55.8729 29.9443 55.005Z",
    fill: "#DEE9F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9443 46.6984C29.9443 45.8305 30.6479 45.127 31.5158 45.127H78.0599C78.9277 45.127 79.6313 45.8305 79.6313 46.6984C79.6313 47.5663 78.9277 48.2698 78.0599 48.2698H31.5158C30.6479 48.2698 29.9443 47.5663 29.9443 46.6984Z",
    fill: "#DEE9F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4209 23.2267C30.4209 22.3588 31.1245 21.6553 31.9923 21.6553H61.406C62.2738 21.6553 62.9774 22.3588 62.9774 23.2267V33.7316C62.9774 34.5994 62.2738 35.303 61.406 35.303H31.9923C31.1245 35.303 30.4209 34.5994 30.4209 33.7316V23.2267ZM33.5638 24.7981V32.1601H59.8345V24.7981H33.5638Z",
    fill: "#DEE9F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6235 33.7314H73.5005C71.5131 33.7314 69.8096 32.0279 69.8096 30.0405V26.9175C69.8096 24.9301 71.5131 23.2266 73.5005 23.2266H76.6235C78.611 23.2266 80.3144 24.9301 80.3144 26.9175V30.0405C80.3144 32.0279 78.8949 33.7314 76.6235 33.7314Z",
    fill: "#2DD68A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1164 77.5527H53.5361V86.9255H57.1164V77.5527Z",
    fill: "#DEE9F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8148 77.5527H59.1758V86.9255H64.8148V77.5527Z",
    fill: "#DEE9F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.574 77.5527H66.6943V86.9255H68.574V77.5527Z",
    fill: "#DEE9F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7501 77.5527H70.0957V86.9255H74.7501V77.5527Z",
    fill: "#DEE9F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0623 77.5527H76.1826V86.9255H78.0623V77.5527Z",
    fill: "#DEE9F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.307 77.5527H30.5322V86.9255H33.307V77.5527Z",
    fill: "#DEE9F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3039 77.5527H34.918V86.9255H39.3039V77.5527Z",
    fill: "#DEE9F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0786 77.5527H40.6465V86.9255H42.0786V77.5527Z",
    fill: "#DEE9F2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1809 77.5527H43.6006V86.9255H47.1809V77.5527Z",
    fill: "#DEE9F2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4019 77.5527H48.9697V86.9255H50.4019V77.5527Z",
    fill: "#DEE9F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.7a78ec63c6a8ba15fc6f52adc1adcb7a.svg";
export { ForwardRef as ReactComponent };